import {
  sortBy,
} from 'lodash';

import {
  createOptions,
} from '@/helpers/common';
import * as commonConstants from '@/constants/common';
import * as motorhomeConstants from '@/constants/products/motorhome';

const constants = Object.assign(
  {},
  commonConstants,
  motorhomeConstants,
);

export default (stepNumber) => {
  switch (stepNumber) {
    case 1:
      return {
        vehicleUse: createOptions({
          source: constants.VEHICLE_USE,
          asNumbers: true,
        }),
      };
    case 3:
      return {
        typeOfCover: createOptions({
          source: constants.COVER_TYPE_OF_COVER,
          asNumbers: true,
        }).map(item => ({
          ...item,
          helpText: constants.COVER_TYPE_OF_COVER_DESCRIPTION[item.value],
        })),
        voluntaryExcess: sortBy(createOptions({
          source: constants.COVER_VOLUNTARY_EXCESS,
          asNumbers: true,
        }), ['value']).reverse(),
      };
  }
};
